import { MANIFESTO } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const Manifesto = () => (
  <section
    id="manifest"
    data-testid="manifesto-section"
    className="bg-[#ffffff] text-[#141414] py-28 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-16 flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
          Manifest — sådan tænker jeg e-commerce
        </p>
      </Reveal>

      <div className="flex flex-col">
        {MANIFESTO.map((c) => (
          <Reveal key={c.id} delay={0.05}>
            <div
              data-testid="manifesto-chapter"
              className="relative grid grid-cols-1 lg:grid-cols-12 gap-6 py-14 border-t border-[#e4e4e1]"
            >
              <div className="lg:col-span-4">
                <span className="font-display font-light leading-none text-[7rem] md:text-[10rem] text-[#1f3d2b]/15 select-none block">
                  {c.id}
                </span>
              </div>
              <div className="lg:col-span-8 lg:pt-4">
                <h3 className="font-display font-light text-3xl md:text-4xl lg:text-5xl leading-[1.1] text-balance">
                  {c.title}
                </h3>
                <p className="mt-6 max-w-2xl font-ui text-base md:text-lg text-[#5a5a56] leading-relaxed">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
